import { render, staticRenderFns } from "./ForceBind.vue?vue&type=template&id=1532fa8e&scoped=true&"
import script from "./ForceBind.vue?vue&type=script&lang=js&"
export * from "./ForceBind.vue?vue&type=script&lang=js&"
import style0 from "./ForceBind.vue?vue&type=style&index=0&id=1532fa8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532fa8e",
  null
  
)

export default component.exports